import {Action} from "@ngrx/store";

export const TOGGLE_CHAT_OVERLAY: string = '[chatOverlay] Toggle Chat Overlay';


export class ToggleChatOverlay implements Action {
  readonly type: string = TOGGLE_CHAT_OVERLAY;
  constructor(public payload?: boolean) {}
}

export type ChatOverlaySectionAction = ToggleChatOverlay;

